var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLamp = function SvgLamp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1036",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M143.82 8.539h65.82c-.476 15.108-3.69 30.098-10.474 45.206H153.58c-6.19-14.276-9.165-29.384-9.76-45.206z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M169.65 136.31h14.045V60.054H169.65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1040",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M143.7 187.7h65.701c-.357-15.108-3.57-30.098-10.355-45.206H153.46c-6.19 14.276-9.165 29.384-9.76 45.206z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1042",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M209.4 324.86c-4.523 13.681-17.496 23.674-32.612 23.674-15.354 0-28.089-9.993-32.612-23.674z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1044",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.607 317.85h273.16c-10.117-43.422-39.278-80.539-92.243-109.45-2.618-1.428-2.142-.833-2.142-3.807v-9.16h-80.698v6.9c0 2.736.357 2.141-1.905 3.45-52.25 31.526-81.174 69.713-96.17 112.06z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLamp);
export default ForwardRef;